import styled from 'styled-components';
import { colors } from '../styles/variables';

const OrderItemPriceView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .item-price {
    display: flex;
    justify-content: end;
    align-items: end;
    gap: 16px;
    @media (max-width: 800px) {
      width: 100%;
      border-top: 1px solid ${colors.gray300};
      padding-top: 0.5em;
      margin-top: 0.5em;
      justify-content: flex-end;
    }
  }

  .remove-item {
    display: flex;
    gap: 8px;
    align-items: center;
    text-decoration: none;
    color: ${colors.gray600};
    &:hover {
      color: ${colors.gray800};
    }
  }
`;

export default OrderItemPriceView;
